import 'intersection-observer';
import Scrollama from 'scrollama';
import MoveTo from 'moveto';
/**
 * スクロールしてトップへ戻るボタンの初期化
 */
export const scrollToTop = (selector) => {
    const scrollTopEl = document.querySelector(selector);
    if (!scrollTopEl) {
        return;
    }
    const scrollTopBtnEl = scrollTopEl.querySelector('img');
    if (!scrollTopBtnEl) {
        return;
    }
    const moveTo = new MoveTo();
    scrollTopBtnEl.addEventListener('click', () => {
        moveTo.move(document.body);
    });
    const scroller = Scrollama();
    scroller.setup({
        step: '#js-head, #js-body'
    })
        .onStepEnter(evt => {
        if (evt.direction === 'up' && evt.index === 0) {
            scrollTopEl.classList.remove('active');
        }
        if (evt.index === 1) {
            scrollTopEl.classList.add('active');
        }
    });
};
